import React, { useState } from "react";

import {
  WombatThemeProvider,
  Menu,
  MenuItem,
  MenuLink,
  MenuList,
  DatePicker,
} from ".";
import Button from "./components/Button";
import Container from "./components/Layout/Container";
import Layout from "./components/Layout/Layout";
import ScreenContainer from "./components/Layout/ScreenContainer";
import ScreenHeader from "./components/Layout/ScreenHeader";
import {} from "./components/Menu";
import MenuButton from "./components/Menu/MenuButton";
import Input from "./components/Form/Input";
import Textarea from "./components/Form/Textarea";
import { Checkbox, CheckboxGroup } from "./components/Form/Checkbox";
import { Radio, RadioGroup } from "./components/Form/Radio";
import Tooltip from "./components/Tooltip";
import Badge from "./components/Badge";
import Select from "./components/Form/Select";
import { H1, H2, H3, H4, H5, H6, P } from "./components/Typography";
import Link from "./components/Link";
import AutoComplete from "./components/Form/Input/AutoComplete";
import useGetSkills from "../../graphql/hooks/queries/useGetSkills";
import { useIntl } from "react-intl";
import List from "../utils/List";
import Pagination from "../utils/Pagination";
import SearchPopover from "../utils/SearchPopover";
import UserSearch from "../utils/search/UserSearch";

type WombatPlaygroundScreenProps = Record<string, never>;

const WombatPlaygroundScreen: React.FC<WombatPlaygroundScreenProps> = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [value, onChange] = useState<Date | Date[]>();
  const { locale } = useIntl();

  const data: { f: string; l: string }[] = [
    { f: "x", l: "y" },
    { f: "x", l: "y" },
    { f: "x", l: "y" },
    { f: "x", l: "y" },
  ];

  return (
    <WombatThemeProvider>
      <Layout>
        <ScreenContainer>
          <ScreenHeader
            title="Wombat playground"
            actions={[
              <Menu key="header_secondary_action">
                <MenuButton id="example-button">Actions</MenuButton>
                <MenuList>
                  <MenuItem onSelect={() => alert("Download")}>
                    Download
                  </MenuItem>
                  <MenuLink to="/wombat-playground">Create a Copy</MenuLink>
                  <MenuItem onSelect={() => alert("Mark as Draft")}>
                    Mark as Draft
                  </MenuItem>
                  <MenuItem onSelect={() => alert("Delete")}>Delete</MenuItem>
                  <MenuItem onSelect={() => alert("Delete")}>Delete</MenuItem>
                  <MenuItem onSelect={() => alert("Delete")}>Delete</MenuItem>
                  <MenuItem onSelect={() => alert("Delete")}>Delete</MenuItem>
                  <MenuItem onSelect={() => alert("Delete")}>Delete</MenuItem>
                  <MenuItem onSelect={() => alert("Delete")}>Delete</MenuItem>
                  <MenuItem onSelect={() => alert("Delete")}>Delete</MenuItem>
                </MenuList>
              </Menu>,
            ]}
          />
          <Container className="space-y-12">
            <UserSearch onChange={console.log} defaultValue={["48f34b4a-ddf6-4be4-883e-d880dea8ca54"]} />

            <List
              id={"wombat-playground-list"}
              data={data}
              renderAsCard={(data) => (
                <p className="bg-red-400">{`${data.f} ${data.l}`}</p>
              )}
              renderAsList={(data) => (
                <p className="bg-blue-400">{`${data.f} ${data.l}`}</p>
              )}
            >
              <div>Michel c'est le Brésil</div>
            </List>
            <Pagination itemsPerPage={20} itemsCount={234} />
          </Container>
        </ScreenContainer>
      </Layout>
    </WombatThemeProvider>
  );

  return (
    <WombatThemeProvider>
      <Layout>
        <ScreenContainer>
          <ScreenHeader
            title="Wombat playground"
            actions={[
              <Menu key="header_secondary_action">
                <MenuButton id="example-button">Actions</MenuButton>
                <MenuList>
                  <MenuItem onSelect={() => alert("Download")}>
                    Download
                  </MenuItem>
                  <MenuLink to="/wombat-playground">Create a Copy</MenuLink>
                  <MenuItem onSelect={() => alert("Mark as Draft")}>
                    Mark as Draft
                  </MenuItem>
                  <MenuItem onSelect={() => alert("Delete")}>Delete</MenuItem>
                  <MenuItem onSelect={() => alert("Delete")}>Delete</MenuItem>
                  <MenuItem onSelect={() => alert("Delete")}>Delete</MenuItem>
                  <MenuItem onSelect={() => alert("Delete")}>Delete</MenuItem>
                  <MenuItem onSelect={() => alert("Delete")}>Delete</MenuItem>
                  <MenuItem onSelect={() => alert("Delete")}>Delete</MenuItem>
                  <MenuItem onSelect={() => alert("Delete")}>Delete</MenuItem>
                </MenuList>
              </Menu>,
            ]}
          />
          <Container className="space-y-12">
            <DatePicker
              showLeadingZeros
              value={value}
              onChange={onChange}
              minDate={new Date()}
            />
            <div>
              <H1 description="Une petite description de ce quoi ce header est entrain de nous parler">
                H1 - Titre de qualité
              </H1>
              <P>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Blanditiis exercitationem nesciunt dolore natus eveniet autem
                sint molestias quia beatae quo?
              </P>
              <H2 description="Une petite description de ce quoi ce header est entrain de nous parler">
                H2 - Titre de qualité
              </H2>
              <P>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Blanditiis exercitationem nesciunt dolore natus eveniet autem
                sint molestias quia beatae quo?
              </P>
              <H3 description="Une petite description de ce quoi ce header est entrain de nous parler">
                H3 - Titre de qualité
              </H3>
              <P>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Blanditiis exercitationem nesciunt dolore natus eveniet autem
                sint molestias quia beatae quo?
              </P>
              <H4 description="Une petite description de ce quoi ce header est entrain de nous parler">
                H4 - Titre de qualité
              </H4>
              <P>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Blanditiis exercitationem nesciunt dolore natus eveniet autem
                sint molestias quia beatae quo?
              </P>
              <H5 description="Une petite description de ce quoi ce header est entrain de nous parler">
                H5 - Titre de qualité
              </H5>
              <P>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Blanditiis exercitationem nesciunt dolore natus eveniet autem
                sint molestias quia beatae quo?
              </P>
              <H6 description="Une petite description de ce quoi ce header est entrain de nous parler">
                H6 - Titre de qualité
              </H6>
              <P>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Blanditiis exercitationem nesciunt dolore natus eveniet autem
                sint molestias quia beatae quo?
              </P>
            </div>
            <AutoComplete
              id="bonjour1"
              label="Bonjour"
              query={{
                hook: useGetSkills,
                accessKey: "skills",
                hookOptions: { locale },
              }}
              getValue={(i) => i.id}
              getLabel={(i) => i.name}
              renderItem={(i) => i.name}
            />
            <Button variant="link">Bonjour</Button>
            <Input id="bonjour" srOnlyLabel label="Bonjour" />
            <Textarea
              id="omg"
              label="Bonjour"
              help="Dites bonjour avec des lettres"
              rows={2}
            />
            <CheckboxGroup
              title="Checkbox group"
              description="Un superbe groupe de checkbox... Whaouh"
              display="row"
            >
              <Checkbox
                id="MaisNON1"
                label="Check si tu es content"
                help="Dîtes bonjour avec des lettres"
                variant="boxed"
              />
              <Checkbox
                id="MaisNON2"
                label="Check si tu es content"
                help="Dîtes bonjour avec des lettres"
                variant="boxed"
                checked
                disabled
              />
              <Checkbox
                id="MaisNON3"
                label="Check si tu es content"
                help="Dîtes bonjour avec des lettres"
                variant="boxed"
              />
            </CheckboxGroup>
            <RadioGroup
              title="Radio group"
              description="Un superbe groupe de radio... Whaouh"
            >
              <Radio
                id="MaisOUI1"
                name="A"
                label="Check si tu es content"
                help="Dîtes bonjour avec des lettres"
              />
              <Radio
                id="MaisOUI2"
                name="A"
                label="Check si tu es content"
                help="Dîtes bonjour avec des lettres"
              />
              <Radio
                id="MaisOUI3"
                name="A"
                label="Check si tu es content"
                help="Dîtes bonjour avec des lettres"
              />
            </RadioGroup>
            <RadioGroup
              title="Radio group"
              description="Un superbe groupe de radio... Whaouh"
              display="row"
            >
              <Radio
                id="MaisOUI4"
                name="B"
                label="Check si tu es content"
                help="Dîtes bonjour avec des lettres"
                variant="boxed"
              />
              <Radio
                id="MaisOUI5"
                name="B"
                label="Check si tu es content"
                help="Dîtes bonjour avec des lettres"
                variant="boxed"
              />
              <Radio
                id="MaisOUI6"
                name="B"
                label="Check si tu es content"
                help="Dîtes bonjour avec des lettres"
                variant="boxed"
              />
            </RadioGroup>
            <Button onClick={() => setModalOpen(!modalOpen)}>Open modal</Button>
            <Tooltip label="Pouet poeut dnzioa ndoiaz ndoiazn oidnazoi ndoiaz ndoiazn odinazoi ndoiazndoiaz noidna zoindioazn doianzoidnaioz">
              <p>Pouet</p>
            </Tooltip>
            {/* <Modal
              isOpen={modalOpen}
              onDismiss={() => setModalOpen(false)}
            ></Modal> */}
            <Select
              label="Un beau label"
              id="select-qualitatif"
              searchable
              searchOption={{
                keys: ["title"],
                threshold: 0.2,
                useExtendedSearch: true,
              }}
              multiple
              // canSelectAll
              items={[
                { title: "Titre 1" },
                { title: "Titre 2" },
                { title: "Titre 3" },
                { title: "Titre 4" },
                { title: "Titre 5" },
                {
                  title:
                    "Suefhiop aziohf oiazhfiohazo hfizoa haizohf oiazhfioazh oifazh oifhazoi fhazoih foiazhf ioazhfoih aziofhazoih foiaz",
                },
              ]}
              renderItem={(item) => item.title}
              getValue={(item) => item.title}
            />
            <div className="flex flex-col space-y-2">
              <Badge maxValue={500}>{5000}</Badge>
              <Badge variant="secondary">Bonjour</Badge>
              <Badge variant="danger">Bonjour</Badge>
              <Badge variant="warning">Bonjour</Badge>
              <Badge variant="success">Bonjour</Badge>
              <Badge variant="help">Bonjour</Badge>
              <Badge removable maxValue={500}>
                {5000}
              </Badge>
              <Badge removable variant="secondary">
                Bonjour
              </Badge>
              <Badge removable variant="danger">
                Bonjour
              </Badge>
              <Badge removable variant="warning">
                Bonjour
              </Badge>
              <Badge removable variant="success">
                Bonjour
              </Badge>
              <Badge removable variant="help">
                Bonjour
              </Badge>
            </div>
            <Select
              label="Un beau label"
              id="select-qualitatify"
              items={[
                { title: "Titre 1" },
                { title: "Titre 2" },
                { title: "Titre 3" },
                { title: "Titre 4" },
                { title: "Titre 5" },
                {
                  title:
                    "Suefhiop aziohf oiazhfiohazo hfizoa haizohf oiazhfioazh oifazh oifhazoi fhazoih foiazhf ioazhfoih aziofhazoih foiaz",
                },
              ]}
              renderItem={(item) => item.title}
              getValue={(item) => item.title}
            />

            <Link to="/wombat-playground" variant="button-subtle">
              Un superbe lien
            </Link>
          </Container>
        </ScreenContainer>
      </Layout>
    </WombatThemeProvider>
  );
};

export default React.memo(WombatPlaygroundScreen);
